import React, { useState, useEffect } from 'react';
import { templateApi } from '../../services/consts';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Card,
    CardTitle,
    CardBody
} from 'reactstrap';
import { useForm, Controller } from "react-hook-form";
// import WYSIWYGEditor from "./wysiwyg-add";
import { tokenHeader, getUserToken } from "../../services/user-service";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TemplateAddEditor from './template-add-editor';

const apiEndPoint = templateApi;
const AddTemplate = (props) => {

    const [id, setId] = useState(0);
    const [name, setName] = useState('');
    const [slug, setSlug] = useState('');
    const [subject, setSubject] = useState('');
    const [type, setType] = useState('');
    const [htmlBody, setHtmlBody] = useState('');
    const [textBody, setTextBody] = useState('');
    const [fetched, setFetched] = useState(false);
    const [label, setLabel] = useState('Add Template');
    const [nameIsValid, setNameIsValid] = useState(false);
    const [slugIsValid, setSlugIsValid] = useState(false);
    const [subjectIsValid, setSubjectIsValid] = useState(false);
    const [htmlIsValid, setHtmlIsValid] = useState(false);
    const [msgIsValid, setMessageIsValid] = useState(false);
    const [typeIsValid, setTypeIsValid] = useState(false);

    var doCancel = () => {
        props.history.push('/templates');
    }

    useEffect(() => {
        if (props.match.params.id != undefined && !fetched) {
            setFetched(true);
            setLabel('Update Template');
            fetch(apiEndPoint + "/" + props.match.params.id, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    [tokenHeader]: getUserToken()
                }
            })
                .then(res => res.json())
                .then(function (result) {
                    setId(result.id);
                    setName(result.name);
                    setSlug(result.slug);
                    setSubject(result.subject);
                    setType(result.type);
                    setHtmlBody(result.htmlBody);
                    setTextBody(result.textBody);
                })
        }
    })

    var addTemplate = (e) => {
        e.preventDefault();
        let methodType = 'post';
        var template = {
            name: name,
            slug: slug,
            subject: subject,
            type: type,
            htmlBody: htmlBody,
            textBody: textBody
        };
        if(template.name == ''){
            toast.error('Name is required');
            return setNameIsValid(true);
        }
        else if (template.slug == '') {
            toast.error('Slug is required');
            return setSlugIsValid(true);
        } else if (template.type == 'Email' && template.subject == '' ) {
            toast.error('Subject is required');
            return setSubjectIsValid(true);
        } else if (template.type == '') {
            toast.error('Type is required');
            return setTypeIsValid(true);
        }
         else if (template.type == 'Email' && template.htmlBody == '' && template.textBody == '') {
            toast.error('HTML Body or Text Body is required');
            return setHtmlIsValid(true);
        } else if (template.type == 'Message' && template.textBody == '') {
            toast.error('Message Body is required');
            return setMessageIsValid(true);
        }
        if (id != 0) { //to update
            methodType = 'put';
            template.id = id;
        }
        fetch(apiEndPoint, {
            method: methodType,
            body: JSON.stringify(template),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                [tokenHeader]: getUserToken()
            }
        }).then(function (result) {
            // console.log(result);
            if(result.status == 500){
                toast.error('Something went wrong !!');
            }else{
                props.history.push('/templates');
            }
        })
    };

    var onHandleChange = (e) => {
        // console.log("e.target.name:" + e.target.name);
        if (e.target.name == 'name') {
            setName(e.target.value);
        } else if (e.target.name == 'slug') {
            setSlug(e.target.value);
        } else if (e.target.name == 'subject') {
            setSubject(e.target.value);
        } else if (e.target.name == 'type') {
            setType(e.target.value);
        } else if (e.target.name == 'htmlBody') {
            setHtmlBody(e.target.value);
        } else if (e.target.name == 'textBody') {
            setTextBody(e.target.value);
        }
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="mdi mdi-plus-box mr-2"> </i>
                    {label}
                </CardTitle>
                <CardBody className="">
                    <Form>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input type="text" onChange={onHandleChange} value={name} name="name" id="name" placeholder="Name" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Slug</Label>
                            <Input type="text" onChange={onHandleChange} value={slug} name="slug" id="slug" placeholder="Slug" />
                        </FormGroup>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input type="select" onChange={onHandleChange} value={type} name="type" id="type">
                                <option hidden>Select Type</option>
                                <option>Email</option>
                                <option>Message</option>
                            </Input>
                        </FormGroup>
                        {type === "Email" && (
                            <FormGroup>
                                <Label>Subject</Label>
                                <Input type="text" onChange={onHandleChange} value={subject} name="subject" id="subject" placeholder="Subject" />
                            </FormGroup>)}
                        {type === "Message" && (
                            <FormGroup>
                                <Label>Message</Label>
                                <Input type="textarea" onChange={onHandleChange} value={textBody} name="textBody" id="textBody" />
                            </FormGroup>)}
                        {type === "Email" && (
                            <FormGroup>
                                {/* <Label for="">Template Editor</Label> */}
                                {htmlBody !== '' &&
                                <TemplateAddEditor showHtml={htmlBody} showContent={(contentData) => { setHtmlBody(contentData) }} />}
                                {htmlBody == '' &&
                                <TemplateAddEditor showHtml={htmlBody} showContent={(contentData) => { setHtmlBody(contentData) }} />}
                            </FormGroup>)}
                        <Button onClick={addTemplate} color="success">{label}</Button>&nbsp;&nbsp;&nbsp;
                        <Button type="btn btn-secondary" onClick={doCancel}>Cancel</Button>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}
export default AddTemplate;